import React from 'react';

import { Chip } from '@infoods/lifebase-ui';
import classes from './ModalTitle.module.scss';

export const ModalTitle = () => {
  return (
    <div className={classes.title}>
      <Chip size="small" color="info" label="New Update" />
      <h2>Important Updates & Features</h2>
    </div>
  );
};
